import React, { useState } from "react";
import { Drawer, Button } from "antd";
import Sidebar from "./Sidebar";

export default function SidebarDrawer() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        style={{
          position: "fixed",
          top: 16,
          left: 16,
          zIndex: 1000,
        }}
      >
        ☰
      </Button>

      <Drawer
        placement="left"
        open={open}
        onClose={() => setOpen(false)}
        styles={{ body: { padding: 0 } }}
        width={220}
      >
        <Sidebar />
      </Drawer>
    </>
  );
}
